import { useSelector } from "react-redux";
import { Container, Row, Card, Col } from "react-bootstrap";
import ProductTypeList from "./ProductTypeList";
import Loading from "./Loading";
import { RootState } from "../reducers";
import { Link } from "react-router-dom";
import { PUBLIC_URL } from "../serviceWorker";
import useIsXS from "../hooks/useIsXS";

const TYPE_HOT_SALES = "Hot Sale";
const SALE_IMAGE = PUBLIC_URL + "img/user/1/sale.jpg";
const WEEKLY_IMAGE = PUBLIC_URL + "img/user/1/weekly.jpg";
const HOT_SALE_IMAGE = PUBLIC_URL + "img/user/1/hot-sale.jpg";
const HOT_SALE_IMAGE_WIDE = PUBLIC_URL + "img/user/1/hot-sale-wide.jpg";

const Home = () => {
  const isXS = useIsXS();
  const product_types = useSelector(
    (state: RootState) => state.shop.product_types
  );
  const isLoading = useSelector((state: RootState) => state.shop.isLoading);

  const hasSales = product_types?.some((type) => type.name === TYPE_HOT_SALES);

  const renderSalesImage = (image: string, link: string) => (
    <Link to={link}>
      <Card border="light">
        <Card.Img src={image} />
      </Card>
    </Link>
  );

  return (
    <Container fluid>
      {hasSales ? (
        isXS ? (
          <Row className="mb-3">
            <Col xs={12}>
              {renderSalesImage(HOT_SALE_IMAGE, "/product-type/322")}
            </Col>
          </Row>
        ) : (
          <Row className="mb-3">
            <Col xs={12} className="d-flex justify-content-center">
              {renderSalesImage(HOT_SALE_IMAGE_WIDE, "/product-type/322")}
            </Col>
          </Row>
        )
      ) : (
        <Row className="g-1 mb-1">
          <Col xs={12} md={8}>
            {renderSalesImage(WEEKLY_IMAGE, "/product-type/weekly")}
          </Col>
          <Col xs={12} md={4}>
            {renderSalesImage(SALE_IMAGE, "/product-type/187")}
          </Col>
        </Row>
      )}
      {!isLoading && product_types?.length ? (
        <ProductTypeList productTypes={product_types} />
      ) : (
        <Loading />
      )}
    </Container>
  );
};

export default Home;
